export default __webpack_public_path__ + "static/media/success.a0f33d50.jpg";